<template>
	<li v-if="group.groupName" class="group-name-list-item">
		<div style="display:flex">
			<span v-if="group.admin === $store.state.user.authUser.uid" title="You are the admin">
				<ion-icon name="ios-lock"></ion-icon>
			</span>
			<span class="group-name">{{group.groupName}}</span>
		</div>
		<div
			v-if="lastMessage !== null
		&& from !== 'groups'
		&& group.groupName.length < 15"
			class="last-message"
		>
			<div class="last-message-header">
				<span>{{lastMessage.user.firstName}}</span> &middot;
				<span>{{lastMessage.dateCreated | onlyTime}}</span>
			</div>
			<span class="last-message-body">{{truncate(lastMessage.message)}}</span>
		</div>
		<div v-else></div>
		<a
			v-if="$store.state.user.authUser.emailVerified"
			type="button"
			class="view-group"
			@click="handleViewGroup()"
		>
			<ion-icon name="arrow-round-forward"></ion-icon>
		</a>
	</li>
	<li v-else class="members-list">
		<div style="display:flex">
			<span v-if="group.admin === $store.state.user.authUser.uid" title="You are the admin">
				<ion-icon name="ios-lock"></ion-icon>
			</span>
			<user-images-list :users="group.membersData"></user-images-list>
		</div>
		<div
			v-if="lastMessage !== null
			&& group.membersData.length < 6
			&& from !== 'groups'"
			class="last-message"
		>
			<div class="last-message-header">
				<span>{{lastMessage.user.firstName}}</span> &middot;
				<span>{{lastMessage.dateCreated | onlyTime}}</span>
			</div>
			<span class="last-message-body">{{truncate(lastMessage.message)}}</span>
		</div>
		<div v-else></div>
		<a
			v-if="$store.state.user.authUser.emailVerified"
			type="button"
			class="view-group"
			@click="handleViewGroup"
		>
			<ion-icon name="arrow-round-forward"></ion-icon>
		</a>
	</li>
</template>

<script>
import truncate from "truncate";
import { db } from "../../resources/firebase";
import firebase from "firebase/app";
import { getUser } from "../../api/users";
import GroupsSelectedUsers from "./groupsSearch/GroupsSelectedUsers.vue";
import UserImagesList from "../users/userLists/UserImagesList.vue";
import NoUserImage from "../errors/NoUserImage.vue";

export default {
	data() {
		return {
			showView: false,
			lastMessage: null
		};
	},
	props: {
		group: {
			type: Object
		},
		from: {
			type: String
		}
	},
	beforeMount() {
		this.getLastMessage();
	},
	components: {
		GroupsSelectedUsers,
		UserImagesList,
		NoUserImage
	},
	methods: {
		truncate(text) {
			return truncate(text, 40);
		},
		handleViewGroup() {
			if (!this.$store.state.app.app.groupsModal.show) {
				this.$emit("goToMessageDirectly", this.group);
			} else {
				//Modal already open
				this.$emit("goToMessage", this.group);
			}
		},
		getLastMessage() {
			let message = {};

			db.collection("test_groups")
				.doc(this.group.groupID)
				.collection("messages")
				.orderBy("dateCreated", "desc")
				.limit(1)
				.get()
				.then(snapshot => {
					snapshot.forEach(doc => {
						message = doc.data();
					});
				})
				.then(async () => {
					if (message.hasOwnProperty("senderID")) {
						try {
							message.user = await getUser(message.senderID);

							if (message.type === "leave") {
								message.message = `${message.user.firstName} left the group`;
								this.lastMessage = message;
								return;
							}

							this.lastMessage = message;
						} catch (error) {
							// console.log(error);
							throw new Error(error);
						}
					}
				})
				.catch(error => {
					// console.log(error);
					throw new Error(error);
				});
		}
	}
};
</script>

<style scoped>
li {
	display: grid;
	grid-template-columns: 35% 55% 5%;
	/* margin-bottom: 10px; */
	align-items: center;
	justify-content: flex-start;
	padding: 15px 0px;
}

/* .group-name-list-item {

		justify-content: flex-start;
		margin-bottom: 10px;
		align-items: center;
	} */

.group-name-list-item .group-name {
	border: 1px solid #51c715;
	color: #51c715;
	font-size: 12px;
	border-radius: 25px;
	height: fit-content;
	border-radius: 25px;
	padding: 3px 10px;
}

/* .members-list {
		display: flex;
		justify-content: flex-start;
		margin-bottom: 10px;
		align-items: center;
	} */

.view-group {
	text-align: right;
	font-size: 12px;
	font-weight: bold;
	color: #51c715;
	margin-left: auto;
}

.last-message {
	margin-left: 10px;
	vertical-align: middle;
}

.last-message-header {
	display: block;
	font-size: 11px;
}

.last-message-header span:first-of-type {
	color: #51c715;
}

.last-message-header span:last-of-type {
	color: #b7b7b7;
}

.last-message-body {
	font-size: 13px;
	display: block;
}

ion-icon {
	vertical-align: middle;
	font-size: 17px;
}

ion-icon[name="ios-lock"] {
	font-size: 10px;
	color: #b7b7b7;
	margin-right: 5px;
}

@media only screen and (max-width: 500px) {
	.last-message-header {
		font-size: 10px;
	}

	.last-message-body {
		font-size: 12px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/groups/GroupsListItem.vue